<div class="container-fluid">
  <div class="row">
    <div class="col-60">
      <div class="d-flex flex-row justify-content-center w-100">
        <div class="container-fluid-960 product-container-fluid w-100">
          <div class="row">
            <div class="col-60  reset-padding-col">
              <div class="d-flex flex-column justify-content-center justify-content-lg-start flex-lg-row w-100">
                <div class="box-gallery-1">
                  <div class="swiper-container" [swiper]="config">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide" *ngFor="let item of gallery">
                        <div class="w-100">
                          <picture>
                            <img
                              [src]="item.path"
                              alt="item"
                              class="object-fit-cover gallery-img" width="100%">
                          </picture>
                        </div>
                      </div>
                    </div>
                    <div class="swiper-pagination swiper-pagination-grey"></div>
                  </div>
                </div>
                <div class="d-flex flex-row justify-content-center box-gallery-2">
                  <div class="d-flex flex-column">
                    <div class="w-100 buttons-container align-items-center">
                      <button class="btn btn-elsa text-uppercase elsa-title-font mb-3 w-100"
                              [ngClass]="{'btn-gray': !btn.outline, 'btn-outline-gray': btn.outline}"
                              (click)="btn.action()" *ngFor="let btn of buttons">{{btn.label}}
                      </button>
                    </div>
                    <div>
                      <p>{{'label_operational_lease_available' | translate}} <a class="discover-more-link" [href]="'operational_lease_page_url' | translate | safeUrl">{{'label_operational_lease_discover_more' | translate}}</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
